
const state = {
    ansprechpartner: false,
    bauprojekte: false,
    dienstleister: false,
    kunden: false,
    ausstattungen: false,
    branchen: false,
    hauser: false,
    devMode: false,
    devMail: "pschoepp@i-am.team",
    wohnungen: false,
    users: false,
    projektphasen: false,
    themen: false,
    kunde_wohnungen: false,
    kunde_wohnungen_relation: false,
    assets: "https://" + process.env.VUE_APP_API_HOST + "/assets/",
    mailerURL: "https://infrabau-portal.de/iam-mailer.php",
    editorOptions: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }],],
    animations: {
        standard: {
            enter: "animated fadeIn fast",
            leave: "animated fadeOut fast",
            name: "fadeIn",
            delay: 4000
        },
        fadeIn: {
            enter: "animated fadeIn fast",
            leave: "animated fadeOut fast",
            name: "fadeIn",
            delay: 4000
        },
        slideLtr: {
            enter: "animated fadeIn fast",
            leave: "animated fadeOut fast",
            name: "fadeIn",
            delay: 4000
        },
        popIn: {
            enter: "animated tada fast",
            leave: "animated fadeOut fast",
            name: "popIn",
            delay: 4000
        },
        slideDown: {
            enter: "animated slideDown fast",
            leave: "animated slideUp fast",
            name: "slideDown",
            delay: 4000
        },
        slideUp: {
            enter: "animated slideUp fast",
            leave: "animated slideUp fast",
            name: "slideUp",
            delay: 4000
        }     
    },
    readyState: {
        bauprojekte: false,
        dienstleister: false,
        kunden: false,
        ausstattungen: false,
        hauser: false,
        wohnungen: false,
        users: false,
        kunde_wohnungen: false,
        kunde_wohnungen_relation: false
    },
    endpoint: {
        bauprojekte: "/items/bauprojekt",
        kunden: "/kunde",
        ausstattungen: "/ausstattung",
        dienstleister: "/dienstleister"
    },
    encodedImg: false,
    fileReader: new FileReader,
    toasts: {
        success: {
            theme: 'toasted-primary',
            position: "top-right",
            type: 'success',
            duration: 2000
        },
        failure: {
            theme: 'toasted-primary',
            position: "top-right",
            type: "error",
            duration: 6000
        },
        info: {
            theme: 'toasted-primary',
            position: "top-right",
            type: "info",
            duration: 2000
        },
        longInfo: {
            theme: 'toasted-primary',
            position: 'top-right',
            type: 'info',
            duration: 6000
        }
    },
    validation: {
        wohnung: {
            name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';@&$!?]/
            },
        },
        zimmer: {
            name: {
                minlength: 3,
                maxlength: 0
            },
            qm: {
                minlength: 1,
                special: "isNumber"
            }
        },
        haus: {
            name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/
            }
        },
        bauprojekt: {
            name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain",
                message: "Bitte geben Sie einen Namen mit mindestens 3 Zeichen ein."
            },
        },
        bpDownload: {
            name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain",
                message: "Bitte geben Sie einen Namen mit mindestens 3 Zeichen ein, Sonderzeichen sind nicht erlaubt."
            }
        },
        dienstleister: {
            name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/
            }
        },
        ausstattungen: {
            name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
            }
        },
        kunden: {
            first_name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain"
            },
            last_name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain"
            },
            email: {
                minlength: 6,
                maxlength: 50,
                regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                regex_mode: "match"
            },
            telefon: {
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain",
            },
            strasse: {
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain",
            },
            beschreibung: {
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain",
            },
            ort: {
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain",
            },
            plz: {
                minlength: 3,
                special: "isNumber"
            }
        },
        phasen: {
            titel: {
                minlength: 5,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain"
            },
            kommentar: {
                minlength: 10,
                maxlength: 0,

            }
        },
        admin: {
            first_name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain"
            },
            last_name: {
                minlength: 3,
                maxlength: 0,
                regex: /[*|":<>[\]{}`\\()';]/,
                regex_mode: "notContain"
            },
            email: {
                minlength: 6,
                maxlength: 50,
                regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                regex_mode: "match"
            },
            telefon: {
                minlength: 4,
                maxlength: 0,
                special: "isNumber"
            }
        },
        download_kategorien: {
            name: {
                minlength: 3,
                maxlength: 0
            }
        },
        download: {
            name: {
                minlength: 3,
                maxlength: 0
            },

        },
        upload: {
            name: {
                minlength: 3,
                maxlength: 0
            }
        },
        ausstattung_kategorien: {
            name: {
                minlength: 3,
                maxlength: 0
            }
        },
        ausstattung: {
            name: {
                minlength: 3,
                maxlength: 0
            }
        },
        branchen: {
            name: {
                minlength: 3,
                maxlength: 0
            }
        },
        hilfe_kategorien: {
            name: {
                minlength: 3,
                maxlength: 0
            }
        },
        hilfe_themen: {
            titel: {
                minlength: 3,
                maxlength: 0
            },
            frage: {
                minlength: 3,
                maxlength: 0
            },
            antwort: {
                minlength: 3,
                maxlength: 0
            }
        }
    }
}

const defaultState = Object.assign({}, state);
const defaultReadyState = Object.assign({}, state.readyState);

const getters = {
    devMode: (state) => state.devMode,
    devMail: (state) => state.devMail,
    bauprojekte: (state) => state.bauprojekte,
    dienstleister: (state) => state.dienstleister,
    kunden: (state) => state.kunden,
    ausstattungen: (state) => state.ausstattungen,
    readyState: (state) => state.readyState,
    encodedImg: (state) => state.encodedImg,
    animations: (state) => state.animations,
    toasts: (state) => state.toasts,
    hauser: (state) => state.hauser,
    wohnungen: (state) => state.wohnungen,
    validation: (state) => state.validation,
    branchen: (state) => state.branchen,
    users: (state) => state.users,
    editorOptions: (state) => state.editorOptions,
    projektphasen: (state) => state.projektphasen,
    themen: (state) => state.themen,
    kuwo: (state) => state.kunde_wohnungen,
    ansprechpartner: (state) => state.ansprechpartner,
    kunde_wohnungen_relation: (state) => state.kunde_wohnungen_relation,
    assets: (state) => state.assets,
    mailerURL: (state) => state.mailerURL
}

const actions = {
    async addBranche(_, payload) {
        try {
            await this._vm.$directus.items("branchen").createOne(payload);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Erstellen der Branche";
        }
    },
    async deleteBranche(_, id) {
        try {
            //first delete all relations where branche_id is id
            const branchen_relations = await this._vm.$directus.items("dienstleister_branchen").readByQuery({ filter: {branchen_id: id}, limit: -1 });
            const ids = branchen_relations.data.map((o) => {
                return o.id;
            } );

            await this._vm.$directus.items("dienstleister_branchen").deleteMany(ids);
            await this._vm.$directus.items("branchen").deleteOne(id);
        } catch (error) {
            console.log(error);
            throw "Fehler beim Löschen der Branche";
        }
    },
    validateField(_, validationData) {

        //get field rules
        const rules = state.validation[validationData.context][validationData.field];

        //abort if no rules defined
        if (!rules) return true;

        //apply validation
        const value = validationData.value;

        if ("undefined" !== typeof (rules.maxlength) && rules.maxlength > 0 && value.length > rules.maxlength) return false;
        if ("undefined" !== typeof (rules.minlength) && rules.minlength > 0 && value.length < rules.minlength) return false;
        if ("undefined" !== typeof (rules.regex) && rules.regex !== "" && rules.regex_mode == "match" && !rules.regex.test(value)) return false;
        if ("undefined" !== typeof (rules.regex) && rules.regex !== "" && rules.regex_mode == "notContain" && rules.regex.test(value)) return false;
        if ("undefined" !== typeof (rules.special) && rules.special.indexOf("isNumber") > -1 && isNaN(value)) return false;
        return true;
    },
    async generatePassword() {
        return Math.random().toString(36).substr(2, 10);
    },
    async parseError(_, error) {
        let parsed = error.message;
        if (error.message != undefined && error.message.indexOf("Duplicate key") > -1 && error.message.indexOf("directus_users") > -1) parsed = "Diese Email Addresse wurde bereits registriert";
        return parsed;
    },
    async createKunde({ dispatch }, payload) {
        let errorCreateUser = false;

        //prepare data needed to create a user
        const createUserPayload = {
            first_name: payload.first_name,
            last_name: payload.last_name,
            email: payload.email,
            password: payload.password,
            status: payload.status,
            role: payload.role
        }

        if (payload.image) createUserPayload['image'] = payload.image;
        if (!payload.image) createUserPayload['image'] = payload.image;

        let createKundePayload = {
            first_name: payload.first_name,
            last_name: payload.last_name,
            email: payload.email,
            status: "published"
        }

        if (payload.image) createKundePayload['image'] = payload.image;

        try {
            const responseCreateUser = await this._vm.$directus.users.createOne(createUserPayload);
            createKundePayload['user'] = responseCreateUser.id;
            await dispatch("chat/createKundeDialogue", responseCreateUser.id, {root:true});
            //if (payload.sendMail) dispatch("sendPasswordMail", { id: responseCreateUser.id, email: responseCreateUser.email });
        } catch (error) {
            console.log(error);
            const parsed = await dispatch("parseError", error);
            errorCreateUser = true;
            throw (parsed);
        }

        //abort if Error in User Creation
        if (errorCreateUser) return;

        //return value
        let responseCreateKunde;
        //create the kunde if the user was created succesfully
        try {
            responseCreateKunde = await this._vm.$directus.items("kunde").createOne(createKundePayload);
        } catch (error) {
            const parsed = await dispatch("parseError", error);
            throw (parsed);
        }
        return responseCreateKunde;
    },
    async apiGetKundeWohnungen({ commit }) {
        try {
            
            const response = await this._vm.$directus.items("kunde_wohnung").readByQuery({ limit: -1 });
            if(response.data) commit("setKundeWohnungenRelation", response.data);
            commit("setReadyState", "kunde_wohnungen_relation");
        } catch(error) {
            throw "Error getting Kunde Wohnungen Relation";
        }
    },
    async sendPasswordMail({ dispatch }, userdata) {
        try {
            const mailTarget = state.devMode ? state.devMail : userdata.email;
            dispatch("auth/reqPwReset", mailTarget, { root: true });
            return true;
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Fehler beim Versand der Email.");
        }
    },
    async apiGetThemen({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("ansprechpartner_themen").readByQuery({ fields: "*.*.*" });
            commit("setThemen", response.data);
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim laden der Ansprechpartner Themengebiete.";
        }
    },
    async apiGetAnsprechpartner({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("ansprechpartner").readByQuery({ status: "published", limit: -1 });
            commit("setAnsprechpartner", response.data);
        } catch (error) {
            await dispatch("parseError");
            throw "Fehler beim Laden der Ansprechpartner";
        }
    },
    async apiGetBauprojekte({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("bauprojekt").readByQuery({ filter: {status: "published"}, limit: -1 });
            commit("setBauprojekte", response.data);
            await dispatch("getAssets", "bauprojekte");
            await dispatch("apiGetHouses");
            await dispatch("apiGetProjektphasen");
            commit("setReadyState", "bauprojekte");
        } catch (error) {
            console.log(error);
            await dispatch("parseError", error);
            throw ("Error fetching Bauprojekte");
        }
    },
    async apiGetProjektphasen({ commit }) {
        try {
            const response = await this._vm.$directus.items("projektphasen").readByQuery({ status: "published", limit: -1 });
             commit("setProjektphasen", response.data);
        } catch (error) {
            console.log("=============== Projektphasen Error ====================");
            console.log(error);
            throw "Fehler beim laden der Projektphasen";
        }
    },
    async apiGetKunden({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("kunde").readByQuery({ status: "published", limit: -1 });
            commit("setKunden", response.data);
            commit("setReadyState", "kunden");
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error fetching Kunden");
        }
    },
    async apiGetDienstleister({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("dienstleister").readByQuery({ status: "published", limit: -1 });
            commit("setDienstleister", response.data);
            await dispatch("getAssets", "dienstleister");
            commit("setReadyState", "dienstleister");
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error fetching Dienstleister");
        }
    },
    async apiGetBranchen({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("branchen").readByQuery({ status: "published", limit: -1 });
            commit("setBranchen", response.data);
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error fetching Branchen. ");
        }
    },
    async apiGetHouses({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("haus").readByQuery({ status: "published", limit: -1 });
            commit("setHauser", response.data);
            await dispatch("apiGetWohnungen");
            commit("setBpHouses");
            commit("setReadyState", "hauser");
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error fetching Houses");
        }
    },
    async apiGetWohnungen({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("wohnung").readByQuery({ status: "published", limit: 1000 });
            commit("setWohnungen", response.data);
            commit("setHausWohnungen");
            commit("setReadyState", "wohnungen");
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error fetching Wohnungen");
        }
    },
    async apiGetUsers({ commit, dispatch }) {
        try {
            const response = await this._vm.$directus.items("directus_users").readByQuery({ status: "active", limit: 1000 });
            commit("setUsers", response.data);
            commit("setReadyState", "users");
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error fetching Users");
        }
    },
    async addWohnung({ dispatch }, payload) {
        //create wohnung


        if(payload.lageicon === null) delete payload.lageicon;
        if(payload.grundriss === null) delete payload.grundriss;

        try {
            await this._vm.$directus.items("wohnung").createOne(payload);
            console.log("creating wohnung");
            await dispatch("apiGetHouses");
        } catch (error) {
            console.log(error);
            throw ("Fehler beim Erstellen der Wohnung");
        }
    },
    async addHaus({ dispatch }, payload) {
        try {
            await this._vm.$directus.items("haus").createOne(payload);
            await dispatch("apiGetHouses");
        } catch (error) {
            console.log(error);
            throw ("Fehler beim Erstellen des Hauses in app.js");
        }
    },
    async getKundeWohnungen({ dispatch }, kundeId) {
        const query = {
            filter: {
                kunde: kundeId,
            },
        };

        try {
            const responseWohnungenRelation = await this._vm.$directus.items("kunde_wohnung").readByQuery(query);
            if (responseWohnungenRelation.data.length == 0) return;
            await dispatch("getWohnungen", responseWohnungenRelation.data);
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim Laden der Kundendaten"
        }
    },
    async getWohnungen({ commit, dispatch }, wohnungen) {
        const wCount = wohnungen.length;
        let result = [];
        for (let i = 0; i < wCount; i++) {
            try {
                const query = {
                    fields: "*.*.*",
                };
                const response = await this._vm.$directus.items("wohnung").readOne(wohnungen[i].wohnung, query);
                result.push(response);
            } catch (error) {
                await dispatch("parseError", error);
                throw "Fehler beim Laden wer Wohnungsobjekte";
            }
        }
        commit("setKundeWohnungen", result);
        commit("setReadyState", "kunde_wohnungen");
    },
    async getAssets({ commit, dispatch }, resource) {
        switch (resource) {
            case "bauprojekte":

                for (let bp in state.bauprojekte) {
                    try {
                        const responseLogo = await dispatch("getAsset", state.bauprojekte[bp].logo);
                        const filterDl = {
                            filter: {
                                bauprojekt_id: state.bauprojekte[bp].id
                            }
                        }

                        if (!state.dienstleister) {
                            await dispatch("apiGetDienstleister");
                        }

                        const responseBadmappe = await dispatch("getAsset", state.bauprojekte[bp].badmappe);
                        const responseGesamt = await dispatch("getAsset", state.bauprojekte[bp].gesamtlageplan);
                        const responseBaubeschreibung = await dispatch("getAsset", state.bauprojekte[bp].baubeschreibung);

                        //get DL of BP 
                        const responseDl = await dispatch("getRelationItems", { collection: "bauprojekt_dienstleister", filter: filterDl });
                        const payload = {
                            logo: responseLogo,
                            bauprojekt: bp,
                            dl: responseDl.data,
                            badmappe: responseBadmappe,
                            gesamtlageplan: responseGesamt,
                            baubeschreibung: responseBaubeschreibung
                        };

                        commit("setBpAssets", payload);
                        //console.log("getAssets for bp finished");

                    } catch (error) {
                        await dispatch("parseError", error);
                        throw "Error fetching Single Asset";
                    }
                }
                break;
            case "dienstleister":
                if (!state.branchen) {
                    try {
                        await dispatch("apiGetBranchen");
                    } catch (error) {
                        await dispatch("parseError", error);
                        throw "Error getting Branchen";
                    }
                }
                for (let dl in state.dienstleister) {
                    try {
                        const filterBranchen = {
                            filter: {
                                dienstleister_id: state.dienstleister[dl].id
                            }
                        }
                        const responseDl = await dispatch("getRelationItems", { collection: "dienstleister_branchen", filter: filterBranchen });
                        const payload = { branche: responseDl.data, dienstleister: state.dienstleister[dl].id };
                        commit("setDlBranchen", payload);
                    } catch (error) {
                        await dispatch("parseError", error);
                        throw ("Error fetching Dienstleister Assets");
                    }
                }
                break;
        }
    },
    async getRelationItems({ dispatch }, query) {
        try {
            const response = await this._vm.$directus.items(query.collection).readByQuery(query.filter);
            
            return response;
        } catch (error) {

            await dispatch("parseError", error);
            throw "Fehler beim Laden Relationaler Daten von " + query.collection;
        }
    },
    async removeItems({ dispatch }, request) {
        if (!request.items.length) return;
        try {
            console.log(request);
            const response = await this._vm.$directus.items(request.collection).deleteMany(request.items);
            return response;
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim Löschen von Elementen in " + request.collection;
        }
    },
    async getAsset({ dispatch }, assetId) {
        if (assetId) {
            assetId = assetId.toString();
            try {
                const response = await this._vm.$directus.files.readOne(assetId);
                return response;
            } catch (error) {
                await dispatch("parseError", error);
                throw ("getAsset Error");
            }
        }

    },
    async encodeImg({ commit }, image) {
        state.fileReader.onloadend = function () {
            state.encodedImg = state.fileReader.result;
            commit("setEncodedImg", state.fileReader.result);
            return state.fileReader.result;
        };
        state.fileReader.readAsDataURL(image);
    },
    async encodeAsync(_, file) {
        return new Promise((resolve) => {
            state.fileReader.onload = () => resolve(state.fileReader.result);
            state.fileReader.readAsDataURL(file)
        })
    },
    async uploadAsset({ dispatch }, upload) {
        try {
            let response = await this._vm.$directus.uploadFiles(upload);
            return response.data.id;
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim Hochladen";
        }
    },
    async mutate({ dispatch }, mutation) {
        try {
            await this._vm.$directus.items(mutation.collection).updateOne(mutation.item, mutation.changes);
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim ändern eines Elements in " + mutation.collection;
        }
    },
    async createMultiple({ dispatch }, data) {
        try {
            await this._vm.$directus.items(data.collection).createMany(data.items);
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim erstellen in CreateMultiple für " + data.collection;
        }
    },
    async updateMultiple({ dispatch }, request) {
        try {
            console.log(request);
            await this._vm.$directus.items(request.collection).updateMany(request.ids, request.change);
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim aktualisieren in updateMultiple für " + request.collection;
        }
    },
    async createAsset({ dispatch }, assetData) {
        try {
            await this._vm.$directus.createItem(assetData)
        } catch (error) {
            await dispatch("parseError", error);
            throw error;
        }
    },
    async createBauprojekt({ dispatch }, data) {
        try {
            const response = await this._vm.$directus.items(data.collection).createOne(data.item);
            return response;
        } catch (error) {
            await dispatch("parseError", error);
            throw error;
        }
    },
    async newBp({ dispatch }, data) {

        const newBp = {
            name: data.name,
            ort: data.ort,
            strasse: data.strasse,
            status: "published"
        }

        try {
            //create the bp and get the id
            let createdBp = await this._vm.$directus.items("bauprojekt").createOne(newBp);
            let createdId = createdBp.data.id;

            if (data.logo) {
                //assign uploaded logo to bp 
                let mutateLogo = {
                    collection: "bauprojekt",
                    item: createdId,
                    changes: {
                        logo: data.logo,
                    }
                }
                await dispatch("mutate", mutateLogo);
            }

            if (data.images.length) {
                //prepare items array
                const galleryImages = data.images.map((img) => { return { bp: parseInt(createdId), image: parseInt(img), status: "published" } });
                //assign images to BP 
                let newImages = {
                    collection: "bp_gallery_images",
                    items: galleryImages
                }
                await dispatch("createMultiple", newImages);
            }
            return true;
        } catch (error) {
            await dispatch("parseError", error);
            throw "Fehler beim erstellen des Bauprojektes";
        }
    },
    async syncDienstleisterBauprojekt({ dispatch }, payload) {
        const searchFilter = {
            filter: {
                bauprojekt_id: payload.bp
            }
        }
        const stored = await this._vm.$directus.items(payload.collection).readByQuery(searchFilter);
        if (stored.data.length) {
            const delete_items = stored.data.map((item) => {
                return item.id;
            });
            try {
                this._vm.$directus.items(payload.collection).deleteMany(delete_items);
            } catch (error) {
                console.log(error);
                console.log("Error deleting Stored Items in SyncRelation.");
            }
        }

        const newItems = payload.items.map((item) => {
            return {
                bauprojekt_id: item.bauprojekt_id,
                dienstleister_id: item.dienstleister_id
            }
        });

        if (!newItems.length) return;
        const savePayload = {
            collection: payload.collection,
            items: newItems
        }
        try {
            dispatch("createMultiple", savePayload);
        } catch (error) {
            await dispatch("parseError", error);
            throw ("Error in syncRelation");
        }
    },
    async updateSingle({ commit, dispatch }, payload) {
        const collection = payload.resource;
        if (!collection) {
            throw "Cannot find Target Array in UpdateSigle or malformed payload";
        }

        if (collection == "bauprojekt") {
            const newState = await this._vm.$directus.items(collection).readOne(payload.id);
            const payloadBauprojekt = newState;

            commit("setBauprojekt", payloadBauprojekt);

            /*
            const filterGallery = {
                filter: {
                    bp: newState.data.id
                }
            }
            */
            const res_logo = await dispatch("getAsset", newState.logo);
            /**
            const res_gallery = await dispatch("getRelationItems", { collection: "bp_gallery_images", filter: filterGallery });

            let galleryImages = [];
            if (res_gallery.length) {
                res_gallery.forEach(async img => {
                    let assetData = await dispatch("getAsset", img.image);
                    galleryImages.push(assetData);
                });
            }
            */

            const filterDl = {
                filter: {
                    bauprojekt_id: newState.id
                }
            }


            await dispatch("apiGetDienstleister");

            const itemIndex = state.bauprojekte.findIndex((item) => {
                return item.id == newState.id;
            });

            //const responseBadmappe = await dispatch("getAsset", state.bauprojekte[itemIndex].badmappe);
            //const responseGesamt = await dispatch("getAsset", state.bauprojekte[itemIndex].gesamtlageplan);
            //onst responseBaubeschreibung = await dispatch("getAsset", state.bauprojekte[itemIndex].baubeschreibung);

            const dienstleister = await dispatch("getRelationItems", { collection: "bauprojekt_dienstleister", filter: filterDl });

            const payloadAssets = {
                logo: res_logo,
                bauprojekt: itemIndex,
                dl: dienstleister.data,
            };

            commit("setBpAssets", payloadAssets);
            commit("setBpHouses");


        }
        if (collection == "wohnung") {
            const response = await this._vm.$directus.items("wohnung").readOne(payload.id);
            const oldItem = state.wohnungen.findIndex(wohnung => wohnung.id == response.id);
            state.wohnungen.splice(oldItem, 1, response.id);
            console.log("next step....");
            commit("setHausWohnungen");
        }
        if (collection == "haus") {
            try {
                const response = await this._vm.$directus.items("haus").readOne(payload.id);
                const oldItem = state.hauser.findIndex(haus => haus.id == response.id);
                if(oldItem) state.hauser.splice(oldItem, 1, response);
                commit("setBpHouses");
                commit("setHausWohnungen");
            } catch(error) {
                console.log(error);
            }

        }
    },
    async removeWohnung({ dispatch }, wohnung_id) {
        try {
            const search_payload = {
                filter: {
                    wohnung: wohnung_id
                }                
            }
            const wohnung_kunde_data = await this._vm.$directus.items("kunde_wohnung").readByQuery(search_payload);
            if (wohnung_kunde_data.data.length > 0) {
                wohnung_kunde_data.data.forEach(async item => {
                    await this._vm.$directus.items("kunde_wohnung").deleteOne(item.id);
                });
            }

            const search_payload_bm = {
                filter: {
                    wohnung_id: wohnung_id
                }                
            }
            const wohnung_bm_data = await this._vm.$directus.items("board_messages_wohnung").readByQuery(search_payload_bm);
            if (wohnung_bm_data.data.length > 0) {
                wohnung_bm_data.data.forEach(async item => {
                    await this._vm.$directus.items("board_messages_wohnung").deleteOne(item.id);
                });
            }

            await this._vm.$directus.items("wohnung").deleteOne(wohnung_id);
            await dispatch("apiGetHouses");

        } catch (error) {
            console.log(error);
            throw ("error deleting wohnung");
        }
    },
    async checkCollectionRelations(_, collection) {
        const result = await this._vm.$directus.getCollectionRelations(collection);
        return result;
    },
    unsetReadyState({ commit }, resource) {
        commit("unsetReadyState", resource);
    },
    async getBpOfHaus(_, haus_id) {
        const haus = state.hauser.find(h => { return h.id == haus_id });
        return haus.haus_bp;
    },
}

const mutations = {
    setBauprojekte: (state, bp) => state.bauprojekte = bp,
    setBauprojekt: (state, bp) => {
        const itemIndex = state.bauprojekte.findIndex((item) => {
            return item.id == bp.id;
        });
        if (itemIndex == -1) {
            state.bauprojekte.push(bp);
        }
        state.bauprojekte.splice(itemIndex, 1, bp);
    },
    setKunden: (state, kunden) => state.kunden = kunden,
    setDienstleister: (state, dienstleister) => state.dienstleister = dienstleister,
    setBpAssets: (state, asset) => {
        if (!state.bauprojekte[asset.bauprojekt]['extended']) {
            state.bauprojekte[asset.bauprojekt] = { ...state.bauprojekte[asset.bauprojekt], extended: {} }
        }
        if (asset.logo) state.bauprojekte[asset.bauprojekt]['extended'] = { ...state.bauprojekte[asset.bauprojekt]['extended'], logo: asset.logo };
        if (asset.gallery) state.bauprojekte[asset.bauprojekt]['extended'] = { ...state.bauprojekte[asset.bauprojekt]['extended'], gallery: asset.gallery };
        let dlArray = [];
        asset.dl.forEach(dl => {
            let res = state.dienstleister.filter(el => el.id == dl.dienstleister_id);
            if (res) {
                dlArray.push(res[0])
            }
        });
       // console.log("got here");
        if (dlArray.length) {
            state.bauprojekte[asset.bauprojekt]['extended'] = { ...state.bauprojekte[asset.bauprojekt]['extended'], dienstleister: dlArray };
        }

        if (state.bauprojekte[asset.bauprojekt].badmappe) {
            state.bauprojekte[asset.bauprojekt]['extended'] = { ...state.bauprojekte[asset.bauprojekt]['extended'], badmappe: asset.badmappe };
        }

        if (state.bauprojekte[asset.bauprojekt].gesamtlageplan) {
            state.bauprojekte[asset.bauprojekt]['extended'] = { ...state.bauprojekte[asset.bauprojekt]['extended'], gesamtlageplan: asset.gesamtlageplan };
        }

        if (state.bauprojekte[asset.bauprojekt].baubeschreibung) {
            state.bauprojekte[asset.bauprojekt]['extended'] = { ...state.bauprojekte[asset.bauprojekt]['extended'], baubeschreibung: asset.baubeschreibung };
        }

    },
    setDlBranchen: (state, payload) => {
        const dl = state.dienstleister.find(el => el.id == payload.dienstleister);
        const dl_idx = state.dienstleister.indexOf(dl);
        let brancheArray = [];
        let brancheStringArray = [];
        for (let br in payload.branche) {
            let branche = state.branchen.find(el => el.id == payload.branche[br].branchen_id);
            brancheArray.push(branche);
            brancheStringArray.push(branche.name);
        }
        if (!state.dienstleister[dl_idx]['extended']) {
            state.dienstleister[dl_idx] = { ...state.dienstleister[dl_idx], extended: {} }
        }
        state.dienstleister[dl_idx]['extended'] = { ...state.dienstleister[dl_idx]['extended'], branchen: brancheArray };
        state.dienstleister[dl_idx]['extended'] = { ...state.dienstleister[dl_idx]['extended'], branchenString: brancheStringArray.join(", ") };
    },
    setBranchen: (state, branchen) => {
        state.branchen = branchen;
    },
    setReadyState: (state, resource) => state.readyState[resource] = true,
    unsetReadyState: (state, resource) => state.readyState[resource] = false,
    setEncodedImg: (state, img) => state.encodeImg = img,
    setDefaultState: (state) => {
        Object.assign(state, defaultState)
        Object.assign(state.readyState, defaultReadyState);
    },
    setHauser: (state, hauser) => {
        state.hauser = hauser
    },
    setWohnungen: (state, wohnungen) => {
        state.wohnungen = wohnungen
    },
    setHausWohnungen: (state) => {
        state.hauser.forEach((haus, idx) => {
            let wohnungen_haus = state.wohnungen.filter(wohnung => wohnung.haus == haus.id);
            if (!haus['extended']) {
                haus = { ...haus, extended: { wohnungen: wohnungen_haus } };
            }
            state.hauser[idx]['extended'] = { ...haus['extended'], wohnungen: wohnungen_haus };
        });
    },
    setBpHouses: (state) => {
        state.bauprojekte.forEach((bp) => {
            let result = state.hauser.filter(
                haus => haus.haus_bp == bp.id
            )
            if (!bp['extended']) {
                bp = { ...bp, extended: {} };
            }
            bp['extended'] = { ...bp['extended'], hauser: result };
        }
        );
    },
    setUsers: (state, payload) => { state.users = payload },
    setProjektphasen: (state, payload) => { state.projektphasen = payload },
    setThemen: (state, payload) => { state.themen = payload },
    setKundeWohnungen: (state, wohnungen) => {
        state.kunde_wohnungen = wohnungen
    },
    setAnsprechpartner: (state, ansprechpartner) => {
        state.ansprechpartner = ansprechpartner;
    },
    setKundeWohnungenRelation: (state, kuwo_rel) => state.kunde_wohnungen_relation = kuwo_rel
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};